import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {actions as authActions} from '../../auth/state/action';
import Button from '../component/Button';
import FloatingDevToggle from '../component/FloadtingDevToggle';
import FloatingDevItem from '../component/FloatingDevItem';
import {showAuthModal} from '../function';
import useLogin from '../hook/useLogin';
import useTheme from '../hook/useTheme';

export default function FloatingDevBox() {
  const {theme, setTheme} = useTheme();
  const [showFloatingBox, setShowFloatingBox] = useState(false);

  const dispatch = useDispatch();
  const {isLogin} = useLogin();

  if (!showFloatingBox) {
    return (
      <div
        className={cn(
          'fixed left-0 bottom-50 z-modalPlus1 bg-black/70',
          'border-t border-r border-b border-solid border-grey-09',
          'rounded-tr-10 rounded-br-10'
        )}
      >
        <Button className="p-15" onClick={() => setShowFloatingBox(true)}>
          Dev
        </Button>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'fixed left-0 bottom-50 z-modalPlus1 bg-black/70 p-20 flex flex-col',
        'border-t border-r border-b border-solid border-grey-09',
        'rounded-tr-10 rounded-br-10'
      )}
    >
      <FloatingDevItem label="theme">
        <FloatingDevToggle
          isActive={theme === 'dark'}
          leftLabel="Dark"
          rightLabel="Light"
          onClickLeft={() => setTheme('dark')}
          onClickRight={() => setTheme('light')}
        />
      </FloatingDevItem>
      <Button
        className="s14-bold-black w-full bg-white rounded-10 p-10 mt-30"
        onClick={() => {
          if (isLogin) {
            dispatch(authActions.fetchLogout());
          } else {
            showAuthModal({titleType: 'loginButton'});
          }
        }}
      >
        {isLogin ? 'Logout' : 'Login'}
      </Button>
      <Button
        className="s14-bold-black w-full bg-white rounded-10 p-10 mt-30"
        onClick={() => setShowFloatingBox(false)}
      >
        Close
      </Button>
    </div>
  );
}
